import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import Modal from '../../../shared/ui/Modal';
import DwCalendar from "./DwCalendar";
import CustomForm from "../../../shared/components/form/CustomForm";
import AddActionButton from "../common/AddActionButton";
import {eventCreateConfig} from "../../../shared/components/form/CalendarEventFormConfig";
import calendarActionCreators from '../../store/calendar/action-creators';
import './PersonalSchedulePage.scss';
import uuidv4 from 'uuid/v4';
import moment from 'moment';
import LoadingButton from "../../../shared/ui/LoadingButton";

function mapStateToProps(state) {
  return {
    events: state.calendar.myList,
    userContext: state.common.userContext,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchMyEventsForDateRange: (startDate, endDate) => {
      return dispatch(calendarActionCreators.fetchMyEventsForDateRange(startDate, endDate));
    },
    createEvent: (formData) => {
      return dispatch(calendarActionCreators.createEvent(formData));
    },
    updateEvent: (event) => {
      return dispatch(calendarActionCreators.updateEvent(event));
    },
    deleteEvent: (event) => {
      return dispatch(calendarActionCreators.deleteEvent(event));
    }
  };
}

class PersonalSchedulePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCreateModal: false,
      showEditModal: false,
      selectedEvent: {},
      eventStart: null,
      eventEnd: null
    }
  }

  componentDidMount() {
    const startDate = moment().startOf('week').format('YYYY-MM-DD');
    const endDate = moment().endOf('week').format('YYYY-MM-DD');

    this.props.fetchMyEventsForDateRange(startDate, endDate);
  }

  get eventsWithDate() {
    return this.props.events.reduce(function (acc, event) {
      return [
        ...acc,
        {
          ...event,
          start: new Date(event.start),
          end: new Date(event.end)
        }
      ];

    }, []);
  }

  closeModal() {
    this.setState({
      showCreateModal: false,
      showEditModal: false
    });
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  onShowCreateModal(start, end) {
    this.setState({
      showCreateModal: true,
      selectedEvent: null,
      eventStart: start,
      eventEnd: end
    })
  }

  formatNewEventData() {
    return {
      start: moment(this.state.eventStart).format('HH:mm'),
      end: moment(this.state.eventEnd).format('HH:mm'),
      date: moment(this.state.eventStart).format('YYYY-MM-DD'),
      dateTo: moment(this.state.eventEnd).format('YYYY-MM-DD'),
      allDay: this.state.eventStart === this.state.eventEnd
    }
  }

  formatEditEventData() {
    return {
      ...this.state.selectedEvent,
      start: moment(this.state.selectedEvent.start).format('HH:mm'),
      end: moment(this.state.selectedEvent.end).format('HH:mm'),
      date: moment(this.state.selectedEvent.start).format('YYYY-MM-DD'),
      dateTo: moment(this.state.selectedEvent.end).format('YYYY-MM-DD'),
      allDay: this.state.selectedEvent.allDay,
      label: this.state.selectedEvent.color? {label:this.state.selectedEvent.label, color: this.state.selectedEvent.color }: null
    }
  }

  createEvent({label, ...formData}) {
    const startDate = moment(`${formData.date} ${formData.start}`, 'YYYY-MM-DD HH:mm');
    const endDate = moment(`${formData.dateTo} ${formData.end}`, 'YYYY-MM-DD HH:mm');

    this.props.createEvent({
      id: uuidv4(),
      start: startDate,
      end: endDate,
      title: formData.title || '(no title)',
      desc: formData.desc || '(no description)',
      type: formData.type,
      allDay: formData.allDay ? formData.allDay : this.state.eventStart === this.state.eventEnd,
      userId: this.props.userContext.userGuid,
      color: label ? label.color: null,
      label: label ? label.label: null,
    });

    this.setState({
      showCreateModal: false
    })
  }

  onShowEditModal(event) {
    this.setState({
      showEditModal: true,
      selectedEvent: event
    })
  }

  updateEvent({label, ...formData}) {
    let events = this.props.events;
    let eventIndex = this.props.events.findIndex(e => e.id === this.state.selectedEvent.id);

    if (eventIndex >= 0) {
      const startDate = moment(`${formData.date} ${formData.start}`, 'YYYY-MM-DD HH:mm');
      const endDate = moment(`${formData.dateTo} ${formData.end}`, 'YYYY-MM-DD HH:mm');

      let event = events[eventIndex];
      event.title = formData.title || '(no title)';
      event.desc = formData.desc || '(no description)';
      event.type = formData.type;
      event.start = startDate;
      event.end = endDate;
      event.color = label ? label.color: null;
      event.label = label ? label.label: null;

      this.props.updateEvent(event);

      this.setState({
        showEditModal: false
      })
    }
  }

  deleteEvent() {
    this.setState({
      isDeleteLoading: true
    })

    this.props.deleteEvent(this.state.selectedEvent)
      .then(() => {
        this.setState({
          isDeleteLoading: false,
          showEditModal: false
        })
      })
  }

  onUpdateEvent(event) {
    this.props.updateEvent(event);
  }

  onUpdateEventsForDateRange(startDate, endDate) {
    this.props.fetchMyEventsForDateRange(startDate, endDate);
  }

  render() {
    return (
      <div className="personal-schedule-page">
        <div className="app-content-header">
          <h4 className="title">Personal schedule</h4>

          <AddActionButton
            label={'event'}
            onAdd={() => this.onShowCreateModal(moment().startOf('hour'), moment().endOf('hour').add(1, 'minutes'))}
          />
        </div>

        <div className="app-content">
          <DwCalendar
            events={this.eventsWithDate}
            canModify={true}
            defaultView='WEEK'
            defaultDate={new Date()}
            showCreateModal={(start, end) => this.onShowCreateModal(start, end)}
            showEditModal={(event) => this.onShowEditModal(event)}
            updateEvent={(event) => this.onUpdateEvent(event)}
            updateEventsForDateRange={(startDate, endDate) => this.onUpdateEventsForDateRange(startDate, endDate)}
          />

          <Modal
            isOpen={this.state.showCreateModal}
            onClose={() => this.closeModal()}
            title="Create new Event"
          >
            <div className="event-date">

            </div>

            <CustomForm
              initialValues={this.formatNewEventData()}
              config={eventCreateConfig}
              onSubmit={(formData) => this.createEvent(formData)}
            />
          </Modal>

          {this.state.selectedEvent &&
            <Modal
              isOpen={this.state.showEditModal}
              onClose={() => this.closeModal()}
              title="Event Details"
            >
              <CustomForm
                initialValues={this.formatEditEventData()}
                config={eventCreateConfig}
                onSubmit={(formData) => this.updateEvent(formData)}
              />
              {this.state.showEditModal && (<div className="text-right p-3">
                <LoadingButton danger text="Delete event" onClick={() => this.deleteEvent()}/>
              </div>)}
            </Modal>
          }
        </div>
      </div>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalSchedulePage));
